import { dataHooks } from '@wix/data-hooks'

export const wixMobileDomainNFDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  input: {}
  next: {}
  back: {}
  skip: {}
  successMessage: {}
}>('wix-mobile-domain-nf')
